import { Button, Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import React from 'react';
import { CALENDAR_LINK } from '../constants/demo-link';
import { sendCtaClickEvent } from '../tracking';
import { EarlyAccessDialog } from './EarlyAccessDialog';

export const GetStartedDialog = ({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const [creatorDialogOpen, setCreatorDialogOpen] = React.useState(false);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <strong>What type of business do you have?</strong>
      </DialogTitle>
      <DialogContent>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          href={CALENDAR_LINK}
          size="large"
          target="_blank"
          onClick={() => {
            sendCtaClickEvent({ label: 'popup-mediaco' });
          }}
        >
          <strong>Premium publisher</strong>
        </Button>
        <br />
        <br />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          href={CALENDAR_LINK}
          size="large"
          target="_blank"
          onClick={() => {
            sendCtaClickEvent({ label: 'popup-mediaco' });
          }}
        >
          <strong>Brand or agency</strong>
        </Button>
        <br />
        <br />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          href={CALENDAR_LINK}
          size="large"
          target="_blank"
          onClick={() => {
            sendCtaClickEvent({ label: 'popup-mediaco' });
          }}
        >
          <strong>Creator network</strong>
        </Button>
        <br />
        <br />
        <Button
          variant="outlined"
          color="primary"
          fullWidth
          onClick={() => {
            sendCtaClickEvent({ label: 'popup-creator' });
            setCreatorDialogOpen(true);
          }}
        >
          <strong>Individual creator</strong>
        </Button>
        <br />
        <br />
      </DialogContent>
      <EarlyAccessDialog
        open={creatorDialogOpen}
        onClose={() => setCreatorDialogOpen(false)}
      />
    </Dialog>
  );
};
